export default __webpack_public_path__ + "22feb101c649acfd92ee55307c98ed4e.svg";